import { useTimeRange } from 'hooks';
import { utcToday } from 'utils/dateUtils';
import TimeRangeReportDialog, { ITimeRangeReportDialogProps } from '../TimeRangeReportDialog/TimeRangeReportDialog';

export type ManagedTimeRangeReportDialogProps = Omit<
  ITimeRangeReportDialogProps,
  'back' | 'forward' | 'backEnabled' | 'forwardEnabled'
>;

const ManagedTimeRangeReportDialog = ({
  timeRange: selectedTimeRange,
  timeRangeType,
  ...other
}: ManagedTimeRangeReportDialogProps) => {
  return (
    <TimeRangeReportDialog
      {...useTimeRange(timeRangeType, selectedTimeRange, null, utcToday().startTime, 'utc')}
      {...other}
    />
  );
};

export default ManagedTimeRangeReportDialog;
